import { render, staticRenderFns } from "./PublishersList.vue?vue&type=template&id=316ee9d1&scoped=true&"
import script from "./PublishersList.vue?vue&type=script&lang=js&"
export * from "./PublishersList.vue?vue&type=script&lang=js&"
import style0 from "./PublishersList.vue?vue&type=style&index=0&id=316ee9d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ee9d1",
  null
  
)

export default component.exports